import { DefaultRootState } from 'react-redux';
import { applyMiddleware, compose, createStore, PreloadedState, Store } from 'redux';
import thunk from 'redux-thunk';

import * as Sentry from '@sentry/browser';
import { routerMiddleware } from 'connected-react-router';
import { initializeFetchCache } from 'utils/fetchCache';
import history from 'utils/history';
import { isLoggingEnabled } from 'utils/sentry';

import createSentryMiddleware from '@hh.ru/redux-sentry-middleware';

import { Action } from 'store/createReducer';
import batched, { BatchAction, batchReducer } from 'store/middlewares/batched';
import fetchRouter from 'store/middlewares/fetchRouter';
import trackUrl from 'store/middlewares/trackUrl';
import createRootReducer from 'store/rootReducer';

declare global {
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
    }
}

const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

export default function configureStore(initialState = {}): Store<DefaultRootState, Action | BatchAction> {
    const middleware = [fetchRouter(initializeFetchCache()), thunk, trackUrl, batched, routerMiddleware(history)];
    if (isLoggingEnabled) {
        middleware.push(createSentryMiddleware(Sentry));
    }

    const composedEnhancers = composeEnhancers(applyMiddleware(...middleware));

    return createStore(
        batchReducer(createRootReducer(history)),
        initialState as PreloadedState<DefaultRootState>,
        composedEnhancers
    );
}
